// Services
export {
  ShopService,
  ArticleService,
  OrderService,
  ingestShopArticleCover,
  ingestExternalImage,
  CatalogSyncService,
  ShopifyAdapter,
} from './services';

export type {
  CatalogSyncResult,
  CatalogAdapter,
  CatalogStore,
  NormalizedProduct,
} from './services';

// Lib
export { formatArticlePrice } from './lib/format-price';

// Types
export type {
  Shop,
  ShopInsert,
  ShopUpdate,
  ShopArticle,
  ShopArticleInsert,
  ShopArticleUpdate,
  ShopOrder,
  ShopOrderInsert,
  ShopOrderUpdate,
  ShopOrderLine,
  ShopOrderLineInsert,
  ShopOrderStatus,
  ShopPaymentStatus,
  ShopWithStats,
  ShopOrderWithLines,
  CartItem,
  CreateOrderInput,
} from './types';

// Schemas
export {
  CreateShopSchema,
  UpdateShopSchema,
  CreateArticleSchema,
  UpdateArticleSchema,
  CreateOrderSchema,
  UpdateOrderStatusSchema,
  LocalizedTextSchema,
} from './schemas';

export type {
  CreateShopInput,
  UpdateShopInput,
  CreateArticleInput,
  UpdateArticleInput,
  UpdateOrderStatusInput,
} from './schemas';
